import './buttons.css'
export const Buttons = ({currentIndex, allMessages,buttons, handleButtonClick}) => {
  const isUiDisabled = allMessages.some(
    (item, index) => index > currentIndex
  );
    return <>
                <div className="row g-3 ps-1">
                  {buttons.map((btn, idx) => (
                    <div key={idx} className="col-auto">
                      <button
                        key={idx}
                        className={"btn btn-outline-secondary button-hover"}
                        style={{ color: "#5285C0", borderColor: "#4472C4", minWidth: "120px", fontSize:"14px"}}
                        onClick={() => handleButtonClick(btn)}
                        disabled={isUiDisabled}
                      >
                        {btn}
                      </button>
                    </div>
                  ))}
                </div>
</>
};